import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from "@angular/core";
import { VisionboardItem } from "../../../models";

@Component({
    selector: "app-visionboard-workspace-item",
    templateUrl: "./visionboard-workspace-item.component.html",
    styleUrls: ["./visionboard-workspace-item.component.scss"],
    standalone: false
})
export class VisionboardWorkspaceItemComponent implements OnInit, AfterViewInit {
  @Input() item: VisionboardItem;
  @Input() removable: boolean;
  @Input() dragging: boolean;
  @Input() externalDrag: boolean;
  @Input() disableDrag: boolean;
  @Input() sizeFactor: number = 1;
  @Output() removed: EventEmitter<VisionboardItem>;

  constructor() {
    this.removed = new EventEmitter<VisionboardItem>();
    this.disableDrag = false;
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    if (this.item) {
      const element = document.getElementById(`visionboard-workspace-item-image-${this.item.internalId}`);

      if (element) {
        const size = this.item.getFreeFormSize(this.sizeFactor);

        element.style.width = `${size.w}px`;
        element.style.height = `${size.h}px`;
      }
    }
  }

  onRemoveClick(): void {
    this.removed.emit(this.item);
  }

  onMouseEnter(): void {
    this.item.static = true;
  }

  onMouseLeave(): void {
    this.item.static = false;
  }
}
